<template>
  <datepicker
    v-model="date"
    :input-class="size ? `form-control-${size}` : ''"
    :language="sk"
    bootstrap-styling
    monday-first
    :format="format"
    v-bind="$attrs"
    @input="update"
  />
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { sk } from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Datepicker,
  },
  props: {
    value: {
      type: [Object, String],
      required: false,
    },
    size: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default() {
        return 'dd.MM.yyyy'
      },
    },
  },
  data() {
    return {
      sk: sk,
      date: null,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.date = val
      },
      immediate: true,
    },
  },
  methods: {
    update() {
      this.$emit(
        'input',
        this.$moment(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      )
    },
  },
}
</script>
<style></style>
